export const BASEURL = "https://b2b.pinteg.com.tr/api";

export const authURL = `${BASEURL}/auth` 
export const loginURL = `${BASEURL}/dealerLogin` 
export const userURL = `${BASEURL}/user` 
export const csrfURL = `${BASEURL}/get-csrf-token` 